import React from "react";
import { GradeAttributeCardWrapper } from "./styles";
import { Ptag } from "components/core";
import { formatPlanOverviewValue } from "utlis/utils";

function GradeAttributeCard({ title, limit, remarks, children }) {

  // if (!limit || !remarks || !children) return null;
  // return (
  //   <GradeAttributeCardWrapper>
  //     <header>
  //       <Ptag color="white">{title}</Ptag>
  //     </header>
  //     {children ? (
  //       <article>{children}</article>
  //     ) : (
  //       <article>
  //         <Ptag fontWeight="400" color="#4a4a4a" marginBottom="8px">
  //           Limit
  //         </Ptag>
  //         <Ptag fontWeight="700" color="#4a4a4a" fontSize="16px">
  //           {formatPlanOverviewValue(limit)}
  //         </Ptag>
  //         {remarks && (
  //           <Ptag fontWeight="400" color="#4a4a4a" marginTop="18px" letterHeight="18px">
  //             Remarks: {remarks}
  //           </Ptag>
  //         )}
  //       </article>
  //     )}
  //   </GradeAttributeCardWrapper>
  // );

  return (
    <div className="maternity-card-css">
      <div class="spacing-css">
        <div>
          <span className="maternity-card-heading-css">
            {title}
          </span>
        </div>
        <div className="gold-line-css" />
      </div>

      <div style={{
        display: "flex",
        flexDirection: "column",
        marginTop: "16px",
        gap: "8px"
      }}>
        <span className='maternity-max-limit-heading'>
          {"Max Limit"}
        </span>
        <span className='maternity-max-limit-value'>
          {limit ? limit : "-"}
        </span>
      </div>

      <div style={{ display: "flex", flexDirection: "column", marginTop: "14px", gap: "8px" }}>
        <span className='maternity-max-limit-heading'>
          Remarks
        </span>
        <span className='maternity-max-limit-value'>
          {remarks ? remarks : "-"}
        </span>
      </div>

    </div>
  )
}

export default GradeAttributeCard;
